import React from 'react';
import clsx from 'clsx';
import intl from 'react-intl-universal';
import AppInfoStyles from '../AppInfo.Styles';
import MeetingSolutionsImage from 'images/MeetingSolutions.png';

export default function AppInfo() {
  const classes = AppInfoStyles.useStyles();
  return (
    <section>
      <h1 className={classes.heading}>{intl.get('components.AppInfo.header')}</h1>
      <p className={clsx(classes.paragraph)}>{intl.get('components.AppInfo.description')}</p>
      <p className={classes.boldParagraph}>{intl.get('components.AppInfo.signUpToday')}</p>
      <img
        className={clsx(classes.image, classes.desktopOnly)}
        alt="lifesize-app-screenshot"
        src={MeetingSolutionsImage}
      ></img>
    </section>
  );
}
